import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { AuthService } from '@core/modules/authentication/services/auth.service';
import { selectUser } from '@core/modules/user/features/user.slice';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { first, switchMap, tap } from 'rxjs/operators';
import { ChangePasswordFormService } from './change-password-form.service';

@Injectable({
  providedIn: 'any'
})
export class ManagerAccountService {
  constructor(
    private changePasswordFormService: ChangePasswordFormService,
    private store: Store,
    private messageService: MessageService,
    private authService: AuthService,
    private translateService: TranslateService
  ) {}

  getErrorsList() {
    return {
      currentPassword: {
        required: 'form.errors.required'
      },
      newPassword: {
        required: 'form.errors.required',
        pattern: 'form.errors.pattern'
      },
      confirmPassword: {
        required: 'form.errors.required',
        confirmPassword: 'form.errors.confirm-password'
      }
    };
  }

  initChangePasswordForm(): UntypedFormGroup {
    return this.changePasswordFormService.initForm();
  }

  changePassword(
    currentPassword: string,
    newPassword: string,
    confirmPassword: string
  ): Observable<void> {
    return this.store.select(selectUser).pipe(
      first(),
      switchMap((user) =>
        this.authService.changePassword(
          currentPassword,
          newPassword,
          confirmPassword,
          user?.id!
        )
      ),
      tap(() =>
        this.messageService.add({
          severity: 'success',
          summary: this.translateService.instant('profile.update.success')
        })
      )
    );
  }
}
